import { render, staticRenderFns } from "./PidDashPendingNearMatches.vue?vue&type=template&id=1de8cfd8&scoped=true&"
import script from "./PidDashPendingNearMatches.vue?vue&type=script&lang=js&"
export * from "./PidDashPendingNearMatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de8cfd8",
  null
  
)

export default component.exports